import type {
  KizenFieldType,
  VariableCompatibility,
} from 'pages/AutomationEngine/types';
import type { Destination } from './llm-types';
import { AUTOMATION_VARIABLE_DATA_TYPES } from 'pages/AutomationEngine/constants';

export const DESTINATION_TYPES = {
  this_object_field: 'this_object_field',
  variable: 'variable',
  related_object_field: 'related_object_field',
} as const;

export const CONFLICT_RESOLUTIONS = {
  overwrite: 'overwrite',
  add_only: 'add_only',
  update_if_blank: 'update_if_blank',
  overwrite_except_null: 'overwrite_except_null',
} as const;

export const SUPPORTED_FIELD_TYPES: KizenFieldType[] = [
  'checkbox',
  'checkboxes',
  'date',
  'datetime',
  'dropdown',
  'dynamictags',
  'email',
  'integer',
  'longtext',
  'money',
  'phonenumber',
  'radio',
  'rating',
  'relationship',
  'status',
  'team_selector',
  'text',
  'yesnomaybe',
];

export const SUPPORTED_VARIABLE_TYPES: VariableCompatibility = {
  [AUTOMATION_VARIABLE_DATA_TYPES.string]: {
    single: {},
    array: {},
  },
  [AUTOMATION_VARIABLE_DATA_TYPES.number]: {
    single: {},
  },
  [AUTOMATION_VARIABLE_DATA_TYPES.boolean]: {
    single: {},
  },
  [AUTOMATION_VARIABLE_DATA_TYPES.date]: {
    single: {},
  },
  [AUTOMATION_VARIABLE_DATA_TYPES.datetime]: {
    single: {},
  },
  [AUTOMATION_VARIABLE_DATA_TYPES.phone_number]: {
    single: {},
  },
};

export const MAX_OPTIONS = 100;

export const DEFAULT_CONFLICT_RESOLUTION =
  CONFLICT_RESOLUTIONS.overwrite_except_null;

export const defaultDestination: Destination = {
  field: undefined,
  variable: undefined,
  relatedObjectField: undefined,
  conflictResolution: DEFAULT_CONFLICT_RESOLUTION,
  isRequired: false,
  options: [],
  confidenceThreshold: 0.7,
  destinationType: undefined,
};
